import template from './land-status.jade';
import items from '../../../enums/land-status';
import validation from '../../../services/validation';
import { selectAnalyticsOfferStatus } from '../../../../../../shared/selectors/analytics';
import { trackRequiredFieldFill } from '../../../../../../shared/utils/tracking/requiredFields';

export default angular
  .module('cian.addForm.aboutObjectLandStatus', [])
  .directive('cianAfAboutObjectLandStatus', () => ({
    scope: {},
    bindToController: {
      ad: '=',
      form: '=',
    },
    controller(deviceService, store) {
      'ngInject';
      this.isMobile = deviceService.isMobile;
      this.items = items;
      this.validation = validation(this.form, 'land.status', {
        required: 'Обязательное поле',
      });

      this.handleChange = () => {
        const state = store.getState();
        const category = selectAnalyticsOfferStatus(state);

        trackRequiredFieldFill(category, 'building_type');
      };
    },
    controllerAs: 'landStatus',
    template,
  })).name;
